import { withStyles } from '@material-ui/core/styles';
import MuiTooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { BLACK_GREY, TEXT } from '../Colors';
import { BODY } from '../Fonts';


const StyledTooltip = withStyles({
    tooltip: {
        font: BODY,
        color: TEXT,
        backgroundColor: BLACK_GREY
    },
    arrow: {
        color: BLACK_GREY
    }
})(MuiTooltip);

interface TooltipProps {
    label: string | React.ReactNode,
    children: React.ReactElement<any, any>,
    hidden?: boolean,
    interactive?: boolean,
    preferredPlacement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

export const Tooltip: React.FunctionComponent<TooltipProps> = (props) => {

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';
    
    if (props.interactive) {
        return (
            <StyledTooltip className={stylingClassName} title={props.label} placement={props.preferredPlacement} arrow hidden={props.hidden} interactive>
                {props.children}
            </StyledTooltip>
        );
    }
    else {
        return (
            <StyledTooltip className={stylingClassName} title={props.label} placement={props.preferredPlacement} arrow hidden={props.hidden}>
                {props.children}
            </StyledTooltip>
        );
    }
}